import { createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Операции ")
const _hoisted_2 = {
  key: 0,
  class: "text-center p-2 text-secondary"
}
const _hoisted_3 = { class: "d-flex flex-column gap-3" }
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = { class: "ms-auto" }
const _hoisted_6 = {
  key: 0,
  class: "text-secondary"
}
const _hoisted_7 = { class: "text-secondary" }
const _hoisted_8 = { class: "d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_loader = _resolveComponent("b-loader")!
  const _component_g_card = _resolveComponent("g-card")!

  return (_openBlock(), _createBlock(_component_g_card, null, _createSlots({
    header: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      (_ctx.operations.length == 0 && !_ctx.state.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Похоже операций еще нет. "))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.operations, (operation) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `operation_${operation.id}`
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("b", null, _toDisplayString(_ctx.types[operation.type]), 1),
              _createElementVNode("div", _hoisted_5, _toDisplayString(operation.value / 100) + " ₽", 1)
            ]),
            (operation.type === 'waste')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(operation.wash.address), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$moment(operation.created_at).format('DD.MM.YY HH:mm')), 1)
          ]))
        }), 128))
      ]),
      (_ctx.state.isLoading)
        ? (_openBlock(), _createBlock(_component_b_loader, {
            key: 1,
            class: "m-auto",
            style: {"width":"34px"}
          }))
        : _createCommentVNode("", true)
    ]),
    _: 2
  }, [
    (_ctx.total > _ctx.to)
      ? {
          name: "footer",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadOperations && _ctx.loadOperations(...args))),
                class: "ms-auto btn btn-sm btn-secondary"
              }, " Загрузить еще ")
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1024))
}